module.exports = __webpack_public_path__ + "static/media/play-circle-icon.b48953e7.svg";